module.exports = __webpack_public_path__ + "img/S21PhantomPink.257b54ed.jpg";